import React, { useEffect } from "react";
import { BASE_URL_IMAGE } from "@routers/AppRoute";
import { useContext } from "react";
import altImage from '@images/DefaultImage.jpg';
import { CartSVG, HeartSVG, Compare } from "@icons";
import DrawerModal from "@fragments/DrawerModal";
import Button from "@common/Button";
import styled from "styled-components";
import { WebSettingsContext } from "../../../../redux/Providers/WebsettingsProvider";
import { useMediaQuery } from "@material-ui/core";
import { breakpoints } from "@constants/styled-components";
import { respondTo } from "../../../../utilities/styled-components";
import { useState } from "react";
import Units from "../../../common/Units";
import Quantity from "../../../common/Quantity";
import { useGetLoggedInUserInfo } from "@hooks";
import { intitalizeLoader } from "@slices/Products/productSearch";
import { useTranslation } from "react-i18next";
import { DETAILS } from "@constants/Routes";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "@slices/UserAccount/userSlice";

interface IProps {
  listView: boolean;
  products: any;
  productList: any;
  loading: boolean;
  hasErrors: boolean;
  onAddToCartHandler: Function;
  onAddItemToList: Function;
  onQuantityChangeHandler: Function;
  onUnitChangeHandler: Function;
  onAddToCartActon: Function;
}

const ProductsGrid = (props: IProps) => {
  const webSettingsData: any = useContext(WebSettingsContext);
  const isMobile = useMediaQuery(`(max-width:${breakpoints.sm})`);
  const [showUnit, setShowUnit] = useState(
    props.products?.map((item: any) => false)
  );
  const [products, setProducts] = useState(props.products);
  const sessionId = useGetLoggedInUserInfo();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const userInfo = useSelector(userSelector)?.user?.user?.data;
  useEffect(() => {
    setProducts(props.products);
  }, [props.products]);

  const showUnits = (index: number) => {
    setShowUnit((prevState: any) => {
      const copyShowUnit = prevState ? [...prevState] : [1];
      copyShowUnit[index] = true;
      return copyShowUnit;
    });
  };
  const hideUnits = (index: number) => {
    setShowUnit((prevState: any) => {
      const copyShowUnit = prevState ? [...prevState] : [1];
      copyShowUnit[index] = false;
      return copyShowUnit;
    });
  };
  return (
    <GridContainer>
      {products?.map((product: any, index: number) => {
        return (
          <CardProductGrid className="card">
            <Link to={`${DETAILS}/${encodeURIComponent(product?.code)}`}>
              <ImageWrapper>
                {/* <span className='badge'> {'New'}</span> */}

                <img
                  className="img-fluid card-product-img"
                  src={BASE_URL_IMAGE + product.imageUrl}
                  onError={(e: any) => {
                    e.target.onerror = null;
                    e.target.src = altImage;
                  }}
                />
              </ImageWrapper>
              {product.isShowAttentionImage && (
                <img
                  className="inquiryImageGrid"
                  src={BASE_URL_IMAGE + product.attentionImageURL}
                  alt={""}
                />
              )}
            </Link>
            <InfoWrapper onMouseLeave={() => hideUnits(index)}>
              {/* class "label" is gloabel here */}

              <div>
                <ProductCode>
                  <Link to={`${DETAILS}/${encodeURIComponent(product?.code)}`}>
                    <Code className="label">{product?.code}</Code>
                  </Link>
                  <Icons>
                    <HeartSVG
                      className="icon-lg primary-icon-2"
                      onClick={() =>
                        props.onAddItemToList(
                          sessionId,
                          product?.code,
                          props.productList[index]?.quantity,
                          props.productList[index]?.unit
                        )
                      }
                    />
                    {!isMobile ? (
                      <DrawerModal
                        GridView={true}
                        productDetails={product}
                        className="icon-lg primary-icon-2"
                        discountPrice={product?.discountPrice}
                        imageUrl={
                          BASE_URL_IMAGE + product.imageUrl
                            ? BASE_URL_IMAGE + product.imageUrl
                            : altImage
                        }
                        productId={product?.code}
                        productDescription={product?.description}
                        itemStandardPrice={product?.itemStandardPrice}
                        // salesUnit={product.salesUnitsDesc}
                        salesUnit={product?.salesUnitsDesc.map(
                          (address: any) => {
                            return {
                              label: address.salesUnit,
                              value: address.salesUnitDesc,
                              selected:
                                address.salesUnit ===
                                (product?.salesUnit
                                  ? product?.salesUnit
                                  : product?.defaultSalesUnit),
                            };
                          }
                        )}
                        onAddItemToCartHandler={props.onAddToCartHandler}
                        onAddToCartActon={props?.onAddToCartActon}
                      />
                    ) : (
                      ""
                    )}
                  </Icons>
                </ProductCode>
                <div>
                  <Link to={`${DETAILS}/${encodeURIComponent(product?.code)}`}>
                    <Desc>{product?.description}</Desc>
                  </Link>
                </div>
                {webSettingsData?.showPrice && (
                  <Price className="mt-2">
                    {webSettingsData.allowDiscountDisplay ==
                    "*DISCOUNT_PRICE" ? (
                      <span className="price">
                        {webSettingsData?.showCurrencySymbolBefore
                          ? webSettingsData?.currencyCode +
                            " " +
                            product.discountPrice
                          : product.discountPrice +
                            " " +
                            webSettingsData?.currencyCode}
                      </span>
                    ) : webSettingsData.allowDiscountDisplay ==
                      "*ACTUAL_PRICE" ? (
                      <span className="price">
                        {webSettingsData?.showCurrencySymbolBefore
                          ? webSettingsData?.currencyCode +
                            " " +
                            product.actualPrice
                          : product.actualPrice +
                            " " +
                            webSettingsData?.currencyCode}
                      </span>
                    ) : webSettingsData.allowDiscountDisplay == "*ALL_PRICE" ? (
                      product.actualPrice && product.discountPrice ? (
                        <span>
                          <span className="price">
                            {webSettingsData?.showCurrencySymbolBefore
                              ? webSettingsData?.currencyCode +
                                " " +
                                product.discountPrice
                              : product.discountPrice +
                                " " +
                                webSettingsData?.currencyCode}
                          </span>
                          <del
                            className="price-old"
                            style={{ paddingLeft: "5px" }}
                          >
                            {webSettingsData?.showCurrencySymbolBefore
                              ? webSettingsData?.currencyCode +
                                " " +
                                product.actualPrice
                              : product.actualPrice +
                                " " +
                                webSettingsData?.currencyCode}
                          </del>
                        </span>
                      ) : product.discountPrice ? (
                        <span className="price">
                          {webSettingsData?.showCurrencySymbolBefore
                            ? webSettingsData?.currencyCode +
                              " " +
                              product.discountPrice
                            : product.discountPrice +
                              " " +
                              webSettingsData?.currencyCode}
                        </span>
                      ) : product.actualPrice ? (
                        <span className="price">
                          {webSettingsData?.showCurrencySymbolBefore
                            ? webSettingsData?.currencyCode +
                              " " +
                              product.actualPrice
                            : product.actualPrice +
                              " " +
                              webSettingsData?.currencyCode}
                        </span>
                      ) : (
                        ""
                      )
                    ) : webSettingsData.allowDiscountDisplay == "*ALL" ? (
                      product.actualPrice &&
                      product.discountPrice &&
                      product.discountPercentage ? (
                        <span>
                          <span className="price">
                            {webSettingsData?.showCurrencySymbolBefore
                              ? webSettingsData?.currencyCode +
                                " " +
                                product.discountPrice +
                                " " +
                                product.discountPercentage +
                                "%"
                              : product.discountPrice +
                                " " +
                                webSettingsData?.currencyCode +
                                " " +
                                product.discountPercentage +
                                "%"}
                          </span>
                          <del
                            className="price-old"
                            style={{ paddingLeft: "5px" }}
                          >
                            {webSettingsData?.showCurrencySymbolBefore
                              ? webSettingsData?.currencyCode +
                                " " +
                                product.actualPrice
                              : product.actualPrice +
                                " " +
                                webSettingsData?.currencyCode}
                          </del>
                        </span>
                      ) : product.actualPrice && product.discountPrice ? (
                        <span>
                          <span className="price">
                            {webSettingsData?.showCurrencySymbolBefore
                              ? webSettingsData?.currencyCode +
                                " " +
                                product.discountPrice
                              : product.discountPrice +
                                " " +
                                webSettingsData?.currencyCode}
                          </span>
                          <del
                            className="price-old"
                            style={{ paddingLeft: "5px" }}
                          >
                            {webSettingsData?.showCurrencySymbolBefore
                              ? webSettingsData?.currencyCode +
                                " " +
                                product.actualPrice
                              : product.actualPrice +
                                " " +
                                webSettingsData?.currencyCode}
                          </del>
                        </span>
                      ) : product.discountPrice ? (
                        <span className="price">
                          {webSettingsData?.showCurrencySymbolBefore
                            ? webSettingsData?.currencyCode +
                              " " +
                              product.discountPrice
                            : product.discountPrice +
                              " " +
                              webSettingsData?.currencyCode}
                        </span>
                      ) : product.actualPrice ? (
                        <span className="price">
                          {webSettingsData?.showCurrencySymbolBefore
                            ? webSettingsData?.currencyCode +
                              " " +
                              product.actualPrice
                            : product.actualPrice +
                              " " +
                              webSettingsData?.currencyCode}
                        </span>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </Price>
                )}
                {!isMobile && (
                  <UnitQuantityContiner className="mt-2">
                    <div>
                      {webSettingsData?.itemAvailabilityType !== "*NO" && (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {t("CON_AVAILABLE")} :
                          {Boolean(
                            product?.availabilityOfItem === "YesImage" ||
                              product?.availabilityOfItem === "NoImage"
                          ) ? (
                            <div
                              style={{
                                width: "12px",
                                height: "12px",
                                borderRadius: "20px",
                                background:
                                  product?.availabilityOfItem === "NoImage"
                                    ? "red"
                                    : "green",
                                marginLeft: "5px",
                              }}
                            ></div>
                          ) : (
                            product?.availabilityOfItem
                          )}
                        </div>
                      )}
                    </div>
                    <div className="display-flex">
                      {" "}
                      <Units
                        labelText={t("CON_SALES_UNIT")}
                        onChange={(selectedUnit: any) => {
                          props.onUnitChangeHandler(
                            product?.code,
                            selectedUnit,
                            index
                          );
                        }}
                        options={product?.salesUnitsDesc.map((address: any) => {
                          return {
                            label: address.salesUnit,
                            value: address.salesUnitDesc,
                            selected:
                              address.salesUnit ===
                              props.productList[index]?.unit,
                          };
                        })}
                        showLabel={false}
                      />{" "}
                      <Quantity
                        showLabel={false}
                        quantity={props.productList[index]?.quantity}
                        itemNumberOfDecimalsAllowed={
                          props.productList[index]?.itemNumberOfDecimalsAllowed
                        }
                        onChange={(quantity: any, isValid: boolean) => {
                          props.onQuantityChangeHandler(
                            Number(quantity),
                            index,
                            isValid
                          );
                        }}
                      />
                    </div>
                  </UnitQuantityContiner>
                )}
                {isMobile ? (
                  <>
                    <div className="mt-2">
                      {webSettingsData?.itemAvailabilityType !== "*NO" && (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {t("CON_AVAILABLE")} :
                          {Boolean(
                            product?.availabilityOfItem === "YesImage" ||
                              product?.availabilityOfItem === "NoImage"
                          ) ? (
                            <div
                              style={{
                                width: "12px",
                                height: "12px",
                                borderRadius: "20px",
                                background:
                                  product?.availabilityOfItem === "NoImage"
                                    ? "red"
                                    : "green",
                                marginLeft: "5px",
                              }}
                            ></div>
                          ) : (
                            product?.availabilityOfItem
                          )}
                        </div>
                      )}
                    </div>
                    <div>
                      <Units
                        labelText={t("CON_SALES_UNIT")}
                        onChange={(selectedUnit: any) => {
                          props.onUnitChangeHandler(
                            product?.code,
                            selectedUnit,
                            index
                          );
                        }}
                        options={product?.salesUnitsDesc.map((address: any) => {
                          return {
                            label: address.salesUnit,
                            value: address.salesUnitDesc,
                            selected:
                              address.salesUnit ===
                              props.productList[index]?.unit,
                          };
                        })}
                        showLabel={false}
                      />{" "}
                      <Quantity
                        showLabel={false}
                        quantity={props.productList[index]?.quantity}
                        itemNumberOfDecimalsAllowed={
                          props.productList[index]?.itemNumberOfDecimalsAllowed
                        }
                        onChange={(quantity: any, isValid: boolean) => {
                          props.onQuantityChangeHandler(
                            parseInt(quantity),
                            index,
                            isValid
                          );
                        }}
                      />
                    </div>
                  </>
                ) : (
                  ""
                )}
                <Button
                  className="add-to-cart-btn-1"
                  variant="solid"
                  color="primary"
                  onMouseEnter={() => (!isMobile ? showUnits(index) : "")}
                  style={{ width: "100%", marginTop: "8px" }}
                  onClick={() => {
                    if (
                      props.productList[index]?.isCartDisable === null ||
                      props.productList[index]?.isCartDisable === undefined ||
                      props.productList[index]?.isCartDisable === false
                    )
                      props.onAddToCartHandler(
                        sessionId,
                        product?.code,
                        props.productList[index]?.quantity,
                        props.productList[index]?.unit
                      );
                  }}
                  disabled={
                    !product.isBuyingAllowed ||
                    !webSettingsData?.buyEnabledForUser ||
                    !userInfo?.isAuthenticated
                  }
                >
                  <CartSVG className="secondary-icon-2 icon-lg" />{" "}
                  <span>{t("CON_ADD_TO_CART")}</span>
                </Button>
              </div>
            </InfoWrapper>
          </CardProductGrid>
        );
      })}
    </GridContainer>
  );
};

export default ProductsGrid;

const Label = styled.a`
  font-size: var(--base-font-size);
  font-weight: var(--font-weight-medium);
  color: var(--primary-color-2);
  opacity: var(--medium-opacity);
`;

const GridContainer = styled.div`
  display: grid;
  gap: 0px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  ${respondTo.xs`
     gap: 0px;
  `}

  ${respondTo.md`
    grid-template-columns: repeat(4,minmax(0,1fr));
    gap: 0px;
  `}

  ${respondTo.xl`
    grid-template-columns: repeat(5,minmax(0,1fr));
  `}
`;

const ButtonOverlay = styled.a`
  transition: var(--transition05s);
  opacity: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  padding: 5px 0;
  text-align: center;
  position: absolute;
  background-color: var(--primary-color-2);
  border: var(--thin-border) var(--primary-color-1);
  color: var(--primary-color-1);
  box-sizing: border-box;
  border-radius: var(--border-radius);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const CardProductGrid = styled.figure`
  height: 440px;
  margin-bottom: 1px;
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;
  ${respondTo.xs`
  height: auto;
  `}
  ${respondTo.sm`
  min-height: 460px;
  `}

  .row-img {
    height: 100px;
    width: 100px;
  }
`;

const InfoWrapper = styled.figcaption`
  overflow: hidden;
  padding: 2px 20px 10px 20px;
  text-align: left;
`;

const ImageWrapper = styled.div`
  overflow: hidden;
  position: relative;
  border-radius: var(--border-radius);

  object-fit: contain;
  @media (max-width: 550px) {
    min-height: 140px;
    max-height: 140px;
  }

  > img {
    padding: 10px;
    min-width: 100%;
    max-height: 240px;
    max-width: 100%;
    display: inline-block;
  }

  &:hover ${ButtonOverlay} {
    opacity: var(--high-opacity);
  }

  &:hover {
    transform: scale(1.05);
    transition: var(--transition05s);
  }
`;

const Code = styled.a`
  color: var(--primary-color-2) !important;
  opacity: var(--medium-opacity);
  .label {
    color: var(--primary-color-2) !important;
    a {
      color: var(--primary-color-2) !important;
    }
  }
`;
const Desc = styled.a`
  color: var(--primary-color-2);
`;
const Price = styled.div`
  font-weight: var(--font-weight-bold);
  .price-old {
    font-weight: var(--font-weight-regular);
    opacity: var(--high-opacity);
  }
`;

const UnitQuantityContiner = styled.div`
  select {
    min-width: 95px;
    height: 32px;
  }
  .mt-2 {
    .plus,
    .minus {
      padding: 0px;
    }
  }
`;

const Icons = styled.div`
  display: flex;
  width: 60px;
  cursor: pointer;
  justify-content: space-between;
  opacity: var(--medium-opacity);
`;
const ProductCode = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
`;
